{
  "admin": {
    "settings": {
      "upsell": {
        "success": "The changes have been saved."
      },
      "attendee_sources": {
        "success": "The changes have been saved."
      },
      "watchdogs": {
        "success": "The changes have been saved.",
        "modification_not_saved": "Changes are waiting to be saved on this page."
      },
      "permissions": {
        "success": "The changes have been saved."
      }
    }
  },
  "declaration": {
    "deposit": {
      "success": "The deposit has been saved successfully."
    }
  },
  "ticket": {
    "attendees_import": {
      "processing": {
        "title": "Attendees import in progress",
        "message": "You can continue to navigate on the site while waiting for the end of the import"
      },
      "completed": {
        "title": "Attendees import completed",
        "label": "You can check the history"
      },
      "failed": {
        "title": "An error occurred.",
        "description": "Please try again later."
      },
      "error_message": "The template contains errors, please check the history."
    },
    "attendees_bulk": {
      "success": {
        "title": "{count} attendee(s) added successfully."
      },
      "partial": {
        "title": "{created} attendee(s) added, {failed} attendee(s) already exist."
      },
      "failed": {
        "title": "No attendee could be added, they already exist."
      }
    },
    "deposit_management_page": {
      "eps": {
        "processing": {
          "title": "EPS deposit in progress",
          "label": "Attendee(s) {processed}/{total}",
          "preparing": "Preparing the EPS deposit",
          "stages": {
            "FETCHING_EVENT_DOCUMENTS": "Retrieving event documents",
            "FETCHING_ATTENDEE_DOCUMENTS": "Retrieving attendee documents {current}/{total}",
            "FETCHING_LEGAL_ENTITY_DOCUMENTS": "Retrieving legal entity documents {current}/{total}",
            "AUTHENTICATING": "Connecting to EPS",
            "CREATING_EVENT": "Creating the EPS event",
            "PROCESSING_ATTENDEES": "Registering attendees in EPS {current}/{total}"
          }
        },
        "completed": {
          "title": "EPS deposit completed",
          "label": "The EPS deposit was completed successfully"
        },
        "failed": {
          "title": "EPS deposit failed",
          "label": "The EPS deposit could not be completed"
        }
      },
      "documents_download_modal": {
        "completed": {
          "title": "The documents generation is completed",
          "label": "Access the documents"
        },
        "failed": {
          "title": "An error occurred.",
          "description": "Please try again later."
        },
        "automatic_deposit_sent": {
          "title": "Success of automatic deposit sending",
          "description": "You can continue to navigate on the site, a reference will be available soon"
        },
        "manual_deposit_sent": {
          "title": "Success of manual deposit sending",
          "description": "A reference has been generated and is available in your deposit"
        },
        "deposit_error": {
          "title": "Error during deposit sending",
          "description": "Please check the information entered and try again."
        }
      }
    },
    "signatures": {
      "create": {
        "processing": {
          "title": "Signature sending",
          "label": "Processing..."
        },
        "completed": {
          "title": "Signature sending completed",
          "label": "{count} signature(s) sent",
          "label_redirect": "See the sent signatures"
        },
        "completed_with_skipped": {
          "title": "Signature sending completed ({skipped} contract(s) skipped)"
        },
        "partial_failure": {
          "title": "Processing complete, {count} contract(s) could not be sent",
          "label": "{count} signature(s) sent"
        },
        "total_failure": {
          "title": "Signature sending failed ({count} contract(s))"
        },
        "failed": {
          "title": "An error occurred.",
          "description": "Please try again later."
        },
        "skipped": {
          "title": "Signature sending skipped",
          "label": "the signature procedures are already in progress for the selected attendees"
        },
        "skipped_with_batch": {
          "title": "{count} contract(s) skipped",
          "label": "Signature procedures already exist for these attendees"
        }
      },
      "cancel": {
        "processing": {
          "title": "Cancelling signatures",
          "label": "Processing..."
        },
        "completed": {
          "title": "Signatures cancelled",
          "label": "{count} procedure(s) cancelled",
          "label_redirect": "See the cancelled signatures"
        },
        "partial_failure": {
          "title": "Processing complete, {count} procedure(s) could not be cancelled."
        },
        "total_failure": {
          "title": "Signature cancellation failed ({count} procedure(s))"
        },
        "failed": {
          "title": "An error occurred while cancelling signatures.",
          "description": "Please try again later."
        },
        "skipped": {
          "title": "Signature cancellation",
          "label": "No active signature procedures to cancel"
        }
      }
    },
    "clone": {
      "completed": {
        "title": "The ticket cloning is completed",
        "label": "Access the ticket",
        "label_refresh": "You can refresh the page",
        "click_here": "By clicking here"
      }
    },
    "expenses": {
      "process-import": {
        "completed": {
          "title": "Expenses import completed successfully",
          "label": "You can check the history"
        },
        "pending": {
          "title": "Expenses {expenseType} is pending",
          "description": "You can continue to navigate on the site while waiting for the end of the import"
        },
        "failed": {
          "title": "An error occurred.",
          "description": "Please try again later."
        }
      },
      "generate-template": {
        "processing": {
          "title": "Generation in progress",
          "message": "You can continue to navigate on the site while waiting for the end of the generation"
        },
        "completed": {
          "title": "Template generation completed",
          "label": "See the template"
        },
        "skipped": {
          "title": "Template generation skipped",
          "label": "Please try again later."
        },
        "failed": {
          "title": "An error occurred.",
          "description": "Please try again later."
        }
      },
      "generate-contract-zip-file": {
        "processing": {
          "title": "Generation in progress",
          "message": "You can continue to navigate on the site while waiting for the end of the generation"
        },
        "completed": {
          "title": "The zip generation is completed",
          "label": "Access the zip"
        },
        "failed": "An error occurred while generating the zip."
      }
    },
    "info": {
      "agency-export": {
        "title": "Agency export in progress",
        "message": "You can continue to navigate on the site while waiting for the end of the export"
      },
      "agency-export-completed": {
        "title": "Agency export completed",
        "message": "Access to download"
      },
      "failed": {
        "message": "An error occurred while generating the file."
      }
    }
  }
}
